module.exports = __webpack_public_path__ + "static/media/ZHUHAI-1 OHS-03.85111d89.czml";